import { render, staticRenderFns } from "./MarketingResourceEditor.vue?vue&type=template&id=c2c0d118&"
import script from "./MarketingResourceEditor.vue?vue&type=script&lang=js&"
export * from "./MarketingResourceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports